(() => {
  const CONTENT_SELECTOR = '.blog-post-content';
  let dialogEl = null;
  let imgEl = null;

  function ensureDialog() {
    if (dialogEl) return dialogEl;

    dialogEl = document.createElement('dialog');
    dialogEl.className = 'blog-image-zoom-dialog';
    dialogEl.innerHTML = `
      <button type="button" class="blog-image-zoom-dialog__close" aria-label="閉じる">&times;</button>
      <img class="blog-image-zoom-dialog__image" alt="">
    `;
    document.body.appendChild(dialogEl);

    imgEl = dialogEl.querySelector('.blog-image-zoom-dialog__image');
    dialogEl.querySelector('.blog-image-zoom-dialog__close').addEventListener('click', () => dialogEl.close());
    dialogEl.addEventListener('click', (event) => {
      if (event.target === dialogEl) dialogEl.close();
    });

    return dialogEl;
  }

  function largestAvailableSrc(img) {
    const src = img.currentSrc || img.src;
    try {
      const url = new URL(src, location.href);
      if (url.searchParams.has('width')) {
        url.searchParams.set('width', '2048');
      }
      return url.toString();
    } catch {
      return src;
    }
  }

  function openZoom(img) {
    ensureDialog();
    imgEl.src = largestAvailableSrc(img);
    imgEl.alt = img.alt || '';
    dialogEl.showModal();
  }

  document.addEventListener('click', (event) => {
    const content = event.target.closest(CONTENT_SELECTOR);
    if (!content) return;

    const img = event.target.closest('img');
    if (!img || !content.contains(img)) return;

    openZoom(img);
  });
})();
